import { render, staticRenderFns } from "./CountryFlagDisplay.vue?vue&type=template&id=2b5b745c&scoped=true"
import script from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
export * from "./CountryFlagDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b745c",
  null
  
)

export default component.exports